import { render, staticRenderFns } from "./inTagCourse.vue?vue&type=template&id=5fbbfc2c&scoped=true"
import script from "./inTagCourse.vue?vue&type=script&lang=js"
export * from "./inTagCourse.vue?vue&type=script&lang=js"
import style0 from "./inTagCourse.vue?vue&type=style&index=0&id=5fbbfc2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbbfc2c",
  null
  
)

export default component.exports